'use client';

import { useEffect } from "react";
import { mixpanelTrackPageView } from "@/utils/mixpanel";
import CenterLayout from "@/layout/CenterLayout";
import BlogCard from "./_components/BlogCard";
import TagSidebar from "./_components/TagSidebar";
import BlogPageSkeleton from "./_components/BlogPageSkeleton";
import { useFetchBlogs, useFetchTags } from "./_hook";
import { useSearchParams } from "next/navigation";
import { SupportedLanguage } from "@/config/store/globalStore";
import { useSetAtom } from "jotai";
import { currentLanguage } from "@/config/store/globalStore";

interface BlogsPageProps {
  lang: SupportedLanguage;
}

export default function BlogsPage({ lang }: BlogsPageProps) {
  const setLanguage = useSetAtom(currentLanguage);
  const searchParams = useSearchParams();
  const currentTag = searchParams.get('tag') || '';
  const { data: blogs, refresh: refreshBlogs, loading: blogsLoading } = useFetchBlogs(currentTag);
  const { data: tags, loading: tagsLoading } = useFetchTags();

  useEffect(() => {
    // mixpanelTrackPageView('HomePage');
    // Set language from URL parameter
    setLanguage(lang);
  }, [lang, setLanguage])

  useEffect(() => {
    refreshBlogs();
  }, [currentTag, refreshBlogs]);

  // 블로그와 태그 둘 다 로딩 중이면 스켈레톤 표시
  if (blogsLoading || tagsLoading) {
    return (
      <CenterLayout>
        <BlogPageSkeleton />
      </CenterLayout>
    );
  }

  return (
    <CenterLayout>
      <div className="flex flex-col lg:flex-row gap-8">
        {/* Mobile Sidebar - Top */}
        <div className="lg:hidden">
          <TagSidebar />
        </div>

        {/* Main Content */}
        <div className="flex-1">
          <ul className="space-y-6">
            {blogs?.result.map((post: any) => (
              <li key={post.id}>
                <BlogCard blog={post}/>
              </li>
            ))}
          </ul>
        </div>

        {/* Desktop Sidebar - Right, Sticky */}
        <div className="hidden lg:block lg:w-80">
          <TagSidebar className="sticky top-20" />
        </div>
      </div>
    </CenterLayout>
  )
}